'use strict';

const urlUtils = require('../util/urlUtils');
var scrollAnimate = require('app_rws/components/scrollAnimate');

// Swapping "Estimated Total" vs. "Total" labels
// This is only done due to template re-use
$('.before-review-order-stage-label.order-receipt-label').hide();
$('.review-order-stage-label.order-receipt-label').show();

function initializeReturnForm($submitButton, $form) {
    // Disable Submit Return button (will be enabled via quantity selection)
    $submitButton.attr('disabled', 'disabled');

    // Update button class and text, enabling form submission
    $submitButton.removeClass('start-return').addClass('submit-return');
    $submitButton.text($submitButton.data('submit-text'));
    $submitButton.attr('value', 'submit-return');

    // Update return function links
    $('.js-start-return').addClass('u-visually-hidden');

    $form.find('.js-return-form').removeClass('u-visually-hidden');

    // Hide quantity text, show quantity selection
    // Trigger quantity change in case the default value isn't 0 (can happen when use backs up)
    $form.find('.js-card-quantity-count').closest('.line-item-pricing-info').addClass('u-visually-hidden');
    $form.find('.js-return-quantity').trigger('change');

    // Hide shipping/tracking information
    $form.find('.c-order-status__shipping-details').addClass('u-visually-hidden');
    $form.find('.line-item-returned-quantity').closest('.row').addClass('u-visually-hidden');
}

// If the user is clicking this button for the first time, display the form elements
$('.js-order-return-submit').on('click', function (e) {
    var $el = $(this);
    var $form = $el.closest('form');

    if ($el.hasClass('start-return')) {
        e.preventDefault();
        initializeReturnForm($el, $form);
    }
});

$('.js-start-return').on('click', function (e) {
    e.preventDefault();
    var $el = $('.js-order-return-submit');
    var $productSummary = $('.js-product-summary');
    var $form = $el.closest('form');
    $('html, body').animate({
        scrollTop: $($productSummary).offset().top
    }, 'slow');
    initializeReturnForm($el, $form);
});

/**
 * Handles enabling and disabling form elements based on the user's selection.
 *
 * - Disables the submit button if any quantity is selected but no adjustment reason is selected.
 * - Ensures form usability by dynamically enabling or disabling elements based on the input state.
 */
$('.js-return-quantity, .js-return-adjustment-reason').on('change', function (e) {
    var $quantityEls = $('.js-return-quantity');
    var $adjustmentReasonEls = $('.js-return-adjustment-reason');
    var $submitButton = $('.js-order-return-submit');

    $quantityEls.add($adjustmentReasonEls).on('change', function () {
        var submitEnabled = false;

        $quantityEls.each(function (index, quantityEl) {
            var $quantityEl = $(quantityEl);
            var $adjustmentReasonEl = $($adjustmentReasonEls[index]);

            // Check if quantity select has only one option
            if (quantityEl.options.length <= 1) {
                $quantityEl.prop('disabled', true);
                $adjustmentReasonEl.prop('disabled', true);
                return;
            }

            $quantityEl.prop('disabled', false);

            if ($quantityEl.val() > 0) {
                $adjustmentReasonEl.prop('disabled', false);

                // Check if an adjustment reason is selected
                if ($adjustmentReasonEl.prop('selectedIndex') !== 0) {
                    submitEnabled = true;
                } else {
                    // If any quantity is selected and no adjustment reason is selected, disable submit
                    submitEnabled = false;
                    return false; // Exit early from each
                }
            } else {
                $adjustmentReasonEl.prop('selectedIndex', 0).prop('disabled', true);
            }
        });

        // Enable or disable the submit button
        $submitButton.prop('disabled', !submitEnabled);
    });
});

$('.js-print-return-label').on('click', function (e) {
    $('.ups-label-submit').trigger('click');
});

function parseReturnAddress() {
    var shippingAddress = $('.js-summary-details-shipping').children();
    return {
        firstName: shippingAddress.find('.firstName').prop("innerText") || 'Customer',
        lastName: shippingAddress.find('.lastName').prop("innerText") || 'Return',
        address1: shippingAddress.find('.address1').prop("innerText"),
        address2: shippingAddress.find('.address2').prop("innerText"),
        city: shippingAddress.find('.city').prop("innerText"),
        stateCode: shippingAddress.find('.stateCode').prop("innerText"),
        postalCode: shippingAddress.find('.postalCode').prop("innerText")
    }
}

$('.js-order-return-form').on('submit', function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var url = form.attr('action');
    var returnAddress = parseReturnAddress();
    // Disable the submit button upon submission
    $('button[type="submit"]').attr('disabled', true);
    url = urlUtils.addQueryParams(url, returnAddress);

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            if (data.error) {
                $('.js-error-message')
                    .show()
                    .text(data.errorMessage);
                scrollAnimate($('.page'));
                $('button[type="submit"]').attr('disabled', false);
            } else {
                window.location.reload();
            }
            $(this).spinner().stop();
        }, error: function (err) {
            if (err.responseJSON && err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
})
